import { BadgeCheck } from "lucide-react";
import { Reveal } from "@/components/motion";

const TOOLS = [
  "Excel", "Hotel Financial Analysis", "Revenue KPIs", "Market Research",
  "Competitor Benchmarking", "Forecasting", "Feasibility Analysis", "Commercial Strategy",
];

export default function Toolkit() {
  return (
    <section className="border-t border-hairline" data-testid="toolkit-section">
      <div className="mx-auto max-w-[1400px] px-6 py-24 sm:px-10 sm:py-32">
        <div className="grid grid-cols-1 gap-14 lg:grid-cols-12">
          <div className="lg:col-span-7">
            <Reveal>
              <p className="overline-label mb-8 flex items-center gap-3">
                <span className="inline-block h-px w-10 bg-current opacity-40" aria-hidden="true" />
                Analytical toolkit
              </p>
            </Reveal>
            <div className="flex flex-wrap gap-2.5">
              {TOOLS.map((t, i) => (
                <Reveal key={t} delay={i * 0.04} y={14}>
                  <span
                    data-testid={`tool-${t.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                    className="inline-block cursor-default border border-hairline px-4 py-2 text-[12px] font-semibold uppercase tracking-[0.14em] text-smoke transition-colors duration-300 hover:border-moss hover:bg-moss hover:text-paper"
                  >
                    {t}
                  </span>
                </Reveal>
              ))}
            </div>
            <Reveal delay={0.2}>
              <p className="mt-8 max-w-md text-sm leading-relaxed text-fog">
                The instruments behind the case studies below.
              </p>
            </Reveal>
          </div>

          <div className="lg:col-span-5">
            <Reveal delay={0.1}>
              <div className="relative overflow-hidden border border-moss bg-moss p-8 sm:p-10" data-testid="hsmai-badge">
                <div className="absolute -right-10 -top-10 h-40 w-40 rounded-full border border-champagne/20" aria-hidden="true" />
                <div className="absolute -right-4 -top-4 h-40 w-40 rounded-full border border-champagne/10" aria-hidden="true" />
                <div className="flex items-center gap-2 text-champagne">
                  <BadgeCheck size={18} strokeWidth={1.25} />
                  <p className="text-[11px] font-semibold uppercase tracking-[0.24em]">Certified</p>
                </div>
                <p className="mt-6 text-[11px] font-semibold uppercase tracking-[0.24em] text-paper/50">HSMAI</p>
                <h3 className="mt-2 font-serif text-3xl font-light text-paper">Revenue Management Certificate</h3>
                <p className="mt-4 text-sm leading-relaxed text-paper/60">
                  Applied grounding in hotel pricing, demand and commercial performance.
                </p>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
